<template>
  <div class="gallery-item" @click="$emit('click')">
    <div class="show-more" v-if="showMore">
        <div class="show-more__text">{{$t('webinars.gallery_show_more')}}</div>
        <div class="show-more__circle">
            <div class="show-more__count">
              +{{showMoreCount}}
            </div>
        </div>
    </div>
    <div v-if="showMore" class="gallery-item__overlay"></div>
    <div v-if="showOverlay" class="gallery-item__show-overlay"></div>
    <img v-if="src" :src="src" class="gallery-item__image"/>
  </div>
</template>

<script>
  export default {
    props: {
      src: {
        type: [String, null]
      },
      showMore: {
        type: Boolean,
        default: false
      },
      showOverlay: {
        type: Boolean,
        default: false
      },
      showMoreCount: {
        type: Number,
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gallery-item {
    position: relative;
    border: 2px solid white;
    cursor: pointer;
    height: 100%;

    .show-more {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      display: flex;
      z-index: 2;
    }

    .gallery-item__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .show-more__circle {
      height: 50px;
      width: 50px;
      border-radius: 50%;
      color: $color-rwl-blue-100;
      background-color: $color-rwl-white-100;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .show-more__text {
      color: $color-rwl-white-100;
    }

    .show-more__count {
      font-weight: $font-weight-bold;
    }

    .gallery-item__overlay {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      opacity: 0.8;
      background-color: $color-rwl-blue-100;
      z-index: 1;
      transition: opacity 60ms ease-in-out;
    }

    .gallery-item__show-overlay{
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
    }

    &:hover .gallery-item__show-overlay {
      background-color: rgba(255,138,0,.4);
      border: 3px solid #ff8a00;
      transition: background-color 150ms;
    }

    &:hover .gallery-item__overlay {
      background-color: $color-rwl-blue-100;
      opacity: 1;
      transition: background-color 150ms;
    }
  }
</style>
